(function () {
  // Avoid attaching the page-level listeners more than once
  if (window.__pgiSwiperInit) return;
  window.__pgiSwiperInit = true;

  function getSlides(swiper) {
    return Array.prototype.slice.call(swiper.querySelectorAll('[data-pgi-slide]'));
  }

  function wrapIndex(index, total) {
    return ((index % total) + total) % total;
  }

  // Position of a slide relative to the active one, using the shortest path
  // around the loop. direction: 1 = moving forward, -1 = moving back.
  function loopOffset(rawOffset, total, direction, isDragging) {
    var half = total / 2;
    var offset = wrapIndex(rawOffset, total);
    if (offset > half) offset -= total;

    // Tie (even slide count, slide exactly opposite):
    // while dragging, place it on the incoming side; after settling, on the outgoing side
    if (offset === half) {
      var incoming = direction > 0 ? half : -half;
      offset = isDragging ? incoming : -incoming;
    }
    return offset;
  }

  function setActive(swiper, index, dragOffsetPx, direction) {
    var slides = getSlides(swiper);
    var bullets = swiper.querySelectorAll('[data-pgi-bullet]');
    var total = slides.length;
    if (!total) return;

    index = wrapIndex(index, total);
    dragOffsetPx = dragOffsetPx || 0;
    direction = direction || 1;
    var isDragging = dragOffsetPx !== 0;

    slides.forEach(function (slide) {
      var slideIndex = parseInt(slide.getAttribute('data-index'), 10);
      var offset = loopOffset(slideIndex - index, total, direction, isDragging);
      var prevOffset = parseInt(slide.getAttribute('data-offset') || slideIndex, 10);
      var transform = 'translateX(calc(' + offset * 100 + '% + ' + dragOffsetPx + 'px))';

      // Slides wrapping to the other side jump instantly (no visible fly-across)
      if (Math.abs(offset - prevOffset) > 1) {
        slide.style.transition = 'none';
        slide.style.transform = transform;
        void slide.offsetWidth;
        slide.style.transition = '';
      } else {
        slide.style.transform = transform;
      }

      slide.setAttribute('data-offset', offset);
      slide.classList.toggle('is-active', slideIndex === index && !isDragging);
    });

    bullets.forEach(function (bullet, i) {
      bullet.classList.toggle('is-active', i === index);
    });
    swiper.setAttribute('data-active-index', index);
  }

  // Prevent mouse clicks from moving focus into the swiper.
  // Focus inside the card triggers the theme's :focus-within rule,
  // which keeps the quick-buy button visible after hover ends.
  // Clicks and navigation still work; keyboard focus is unaffected.
  document.addEventListener('mousedown', function (event) {
    if (event.target.closest('[data-pgi-pagination], [data-pgi-track]')) {
      event.preventDefault();
    }
  });

  // Bullet clicks (capture phase so nothing else on the page can swallow it first)
  document.addEventListener(
    'click',
    function (event) {
      var pagination = event.target.closest('[data-pgi-pagination]');
      if (!pagination) return;

      var bullet = event.target.closest('[data-pgi-bullet]');

      // Any click inside the pagination area is fully absorbed here.
      // Only an actual bullet click updates the slide.
      event.preventDefault();
      event.stopPropagation();

      if (!bullet) return;
      var swiper = bullet.closest('[data-pgi-swiper]');
      if (!swiper) return;

      var current = parseInt(swiper.getAttribute('data-active-index') || '0', 10);
      var index = parseInt(bullet.getAttribute('data-index'), 10);
      setActive(swiper, index, 0, index >= current ? 1 : -1);

      // Safety: drop focus in case the bullet got it anyway (e.g. touch)
      if (bullet.blur) bullet.blur();
    },
    true
  );

  // Swipe support (mouse drag on desktop, touch/pen drag on mobile, all
  // unified through the Pointer Events API)
  var DRAG_THRESHOLD = 10; // px before a press counts as a drag, not a tap
  var SWIPE_THRESHOLD_RATIO = 0.18; // fraction of slide width to trigger a slide change
  var SWIPE_THRESHOLD_MIN = 40; // px, floor for very narrow slides

  var activeTrack = null;
  var activeSwiper = null;
  var pointerId = null;
  var startX = 0;
  var lastDeltaX = 0;
  var dragging = false; // exceeded DRAG_THRESHOLD
  var justDragged = false; // used to swallow the click that follows a drag
  var trackWidth = 0;

  document.addEventListener('pointerdown', function (event) {
    // Only the primary button/touch/pen starts a drag
    if (event.button && event.button !== 0) return;

    var track = event.target.closest('[data-pgi-track]');
    if (!track) return;

    activeTrack = track;
    activeSwiper = track.closest('[data-pgi-swiper]');
    pointerId = event.pointerId;
    startX = event.clientX;
    lastDeltaX = 0;
    dragging = false;
    trackWidth = track.getBoundingClientRect().width || 1;

    // NOTE: no pointer capture here. Capturing on a simple tap redirects
    // the click to the track instead of the slide link, which breaks navigation.
  });

  document.addEventListener('pointermove', function (event) {
    if (!activeTrack || !activeSwiper || event.pointerId !== pointerId) return;

    var deltaX = event.clientX - startX;

    if (!dragging && Math.abs(deltaX) > DRAG_THRESHOLD) {
      dragging = true;
      activeTrack.setAttribute('data-dragging', '');

      // Capture only once a real drag starts, so we keep getting
      // move/up events even if the pointer leaves the track
      if (activeTrack.setPointerCapture && event.pointerId != null) {
        try {
          activeTrack.setPointerCapture(event.pointerId);
        } catch (e) {
          /* ignore */
        }
      }
    }

    if (!dragging) return;

    // Stop the page/browser from also treating this as a text/image drag
    event.preventDefault();

    lastDeltaX = deltaX;
    var current = parseInt(activeSwiper.getAttribute('data-active-index') || '0', 10);
    var direction = deltaX < 0 ? 1 : -1;

    // No rubber-band: the loop has no ends
    setActive(activeSwiper, current, deltaX, direction);
  });

  function endDrag(event) {
    if (!activeTrack || !activeSwiper || (event && event.pointerId !== pointerId)) return;

    activeTrack.removeAttribute('data-dragging');
    justDragged = dragging;

    // Reset after the click (if any) has fired, so a missing click
    // can never block the next real tap
    if (justDragged) {
      setTimeout(function () {
        justDragged = false;
      }, 0);
    }

    if (dragging) {
      var current = parseInt(activeSwiper.getAttribute('data-active-index') || '0', 10);
      var threshold = Math.max(SWIPE_THRESHOLD_MIN, trackWidth * SWIPE_THRESHOLD_RATIO);
      var direction = lastDeltaX < 0 ? 1 : -1;
      var nextIndex = current;

      if (lastDeltaX <= -threshold) {
        nextIndex = current + 1;
      } else if (lastDeltaX >= threshold) {
        nextIndex = current - 1;
      } else {
        // Snap back: keep the peeking slide on the side it came from
        direction = -direction;
      }

      setActive(activeSwiper, nextIndex, 0, direction);
    }

    activeTrack = null;
    activeSwiper = null;
    pointerId = null;
    dragging = false;
    lastDeltaX = 0;
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  // Prevent navigation when the click was actually the end of a swipe
  document.addEventListener(
    'click',
    function (event) {
      if (!justDragged) return;
      if (!event.target.closest('[data-pgi-track]')) return;
      event.preventDefault();
      event.stopPropagation();
      justDragged = false;
    },
    true
  );

  // Also guard against native browser image/link drag-start on desktop
  document.addEventListener('dragstart', function (event) {
    if (event.target.closest('[data-pgi-track]')) {
      event.preventDefault();
    }
  });
})();